import { ReactComponent as ErrorIcon } from 'Icons/Error.svg';
import React from 'react';
import { getUnarchiveStatusView } from './utils';
import { ArchivingJobExperimentStatusDto } from 'business/models/Models';

export const getUnarchiveStatusCell = (
  status: ArchivingJobExperimentStatusDto | undefined,
  errorMessage?: string) => {
  const { label, variant, tooltip } = getUnarchiveStatusView(status, errorMessage);

  if (variant === 'error') {
    return (
      <span className="inline-flex items-center gap-1 text-red-600" title={tooltip}>
        <ErrorIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
        {label}
      </span>
    );
  }

  if (variant === 'warning') {
    return <span title={tooltip}>{label} ⚠</span>;
  }

  return <>{label}</>;
};
